module.exports = __webpack_public_path__ + "img/knok_install_step10-11_poster.9523e771.png";